import { useEffect, useState } from 'react';

/**
 * 
 * @param {object} opts 
 * @param {import('react').Ref<HTMLVideoElement>} opts.ref
 * @returns 
 */
export default function usePoppedOut(opts) {
  const {
    ref
  } = opts;
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  useEffect(() => {
    const onEnterPiP = () => {
      setIsPoppedOut(true);
    };
    const onLeavePiP = () => {
      setIsPoppedOut(false);
    };
    ref.current?.addEventListener('enterpictureinpicture', onEnterPiP);
    ref.current?.addEventListener('leavepictureinpicture', onLeavePiP);
    return () => {
      ref.current?.removeEventListener('enterpictureinpicture', onEnterPiP);
      ref.current?.removeEventListener('leavepictureinpicture', onLeavePiP);
    };
  }, [ref.current]);
  return isPoppedOut;
}